// extracted by mini-css-extract-plugin
export default {"subTitle":"selectProduct_subTitle__tTBWZ","dataWrapper":"selectProduct_dataWrapper__Xg2yl","dropdownWrapper":"selectProduct_dropdownWrapper__OnkgN"};